import { executionLogDetailsSelector } from "./executionLogDetailsSelector";
import { RootState } from "../../store";

export const executionLogTotalPriceSelector = (
  state: RootState,
): number | undefined => {
  return executionLogDetailsSelector(state)?.total_price;
};
